import PrivateRoute from './PrivateRoute';
import Routes from './Routes';
import StaffRoute from './StaffRoute';

export { Routes as default, PrivateRoute, StaffRoute };
